"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Meta = Meta;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _value = require("../value");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["isArray", "start", "level", "className", "render"];
function Meta(props) {
  var _props$isArray = props.isArray,
    isArray = _props$isArray === void 0 ? false : _props$isArray,
    _props$start = props.start,
    start = _props$start === void 0 ? false : _props$start,
    level = props.level,
    className = props.className,
    render = props.render,
    reset = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var mark = isArray ? '[]' : '{}';
  var cls = "w-rjv-".concat(isArray ? 'brackets' : 'curlybraces', "-").concat(start ? 'start' : 'end', " ").concat(className || '');
  var color = "var(--w-rjv-".concat(isArray ? 'brackets' : 'curlybraces', "-color, #236a7c)");
  if (render) {
    var viev = render((0, _objectSpread2["default"])({
      isArray: isArray,
      level: level,
      className: cls,
      style: {
        color: color
      },
      children: start ? mark.charAt(0) : mark.charAt(1)
    }, reset));
    if (viev) {
      return viev;
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_value.Label, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    color: color,
    className: cls
  }, reset), {}, {
    children: start ? mark.charAt(0) : mark.charAt(1)
  }));
}